import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="relative -mt-10 md:-mt-14 z-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-100/90 backdrop-blur-xl border border-background-300/30 rounded-2xl p-4 md:p-6">
            <div className="grid grid-cols-5 md:grid-cols-10 gap-2 md:gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-1.5 md:gap-2 p-2.5 md:p-3 rounded-xl hover:bg-primary-500/10 transition-all duration-300 group cursor-pointer"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-background-200/60 text-foreground-400 group-hover:text-primary-400 group-hover:bg-primary-500/15 transition-all duration-300">
                    <i className={`${cat.icon} text-lg md:text-xl`}></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-400 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}